import { css } from 'styled-components';
export const screenSizes = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 428,
    tabletS: 640,
    tabletM: 726,
    tablet: 768,
    tabletL: 940,
    laptop: 1024,
    laptopM: 1224,
    laptopL: 1440,
    desktopS: 1660,
    desktop: 1920,
    desktopL: 2560,
};
export default Object.keys(screenSizes).reduce((acc, label) => {
    acc[label] = (...args) => {
        if (args.length > 0) {
            const [firstArg, ...restOfArgs] = args;
            const screenSize = screenSizes[label];
            return css `
        @media (min-width: ${screenSize}px) {
          ${css(firstArg, ...restOfArgs)}
        }
      `;
        }
    };
    return acc;
}, {});
//# sourceMappingURL=media.js.map